/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { Modal as MantineModal, type MantineTheme, createTheme, rem } from '@mantine/core';

import { variablesToken } from '@fai/design-tokens';

import * as classes from './modal.css';

export const modalTheme = createTheme({
  components: {
    Modal: MantineModal.extend({
      defaultProps: { size: 'sm', centered: true },
      vars: (_, props) => {
        switch (props.size) {
          case 'lg': {
            return { root: { '--modal-size': rem(800) } };
          }
          case 'md': {
            return { root: { '--modal-size': rem(640) } };
          }
          case 'sm': {
            return { root: { '--modal-size': rem(560) } };
          }

          default: {
            return {
              root: {
                '--modal-radius': `calc(${variablesToken.radius.md} * var(--mantine-scale))`,
              },
            };
          }
        }
      },
      classNames() {
        return {
          root: classes.root,
          inner: classes.inner,
          content: classes.content,
          header: classes.header,
          overlay: classes.overlay,
          title: classes.title,
          body: classes.body,
          close: classes.close,
        };
      },
    }),
  },
}) as MantineTheme;
